// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/notesEditor/add.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MindmapDashboard{
    padding: 16px 22px;
    background: #f9f9f6;
    height: 100%;
}

.MindmapDashboard_list{
    display: flex;
    flex-wrap: wrap;
    --cols: 4;
    --gap: 39px;
    gap: var(--gap);
}

.MindmapDashboard_icon--add{
    width: 36px;
    height: 36px;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    opacity: 0.4;
}

.MindmapDashboard_item{
    width: calc((100% - var(--gap) * (var(--cols) - 1)) / var(--cols));
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 9px;
}

.MindmapDashboard_item_preview{
    display: flex;
    justify-content: center;
    align-items: center;

    background: #FFFFFF;
    border: 1px solid #CAC4D0;
    box-shadow: 0px 4px 31.4423px rgba(202, 196, 208, 0.56);
    border-radius: 30px;

    width: 100%;
    aspect-ratio: 1;
    padding: 11px;
}

.MindmapDashboard_item_preview:hover{
    border: 1px solid #5f59fb;
}

.MindmapDashboard_item_content{
    border-radius: 20px;
    background-color: #ccc;
    width: 100%;
    height: 100%;
    position: relative;
    overflow: hidden;
}

.MindmapDashboard_item_name{
    font-weight: 400;
    font-size: 16px;
    line-height: 15px;
    text-align: center;
    color: #000000;
}

.MindmapDashboard_contextMenu {
    position: fixed;
    background: white;
    border: 1px solid #E2E9FC;
    border-radius: 8px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.15);
    z-index: 1000;
    min-width: 140px;
    padding: 4px 0;
}

.MindmapDashboard_contextMenu_item {
    padding: 8px 16px;
    cursor: pointer;
    font-size: 14px;
    color: #333;
}

.MindmapDashboard_contextMenu_item:hover {
    background: #f5f5f5;
}

.MindmapDashboard_contextMenu_item--danger {
    color: #ff4444;
}

.MindmapDashboard_contextMenu_item--danger:hover {
    background: #fff0f0;
}

.MindmapDashboard_contextMenu_confirm {
    padding: 8px 16px;
    font-size: 14px;
    color: #333;
    text-align: center;
    border-bottom: 1px solid #E2E9FC;
}

.MindmapDashboard_contextMenu_actions {
    display: flex;
}

.MindmapDashboard_contextMenu_actions .MindmapDashboard_contextMenu_item {
    flex: 1;
    text-align: center;
}
`, "",{"version":3,"sources":["webpack://./src/pages/desktopPage/MindmapDashboard.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,SAAS;IACT,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,2BAA2B;IAC3B,4BAA4B;IAC5B,sBAAsB;IACtB,yDAAyD;IACzD,YAAY;AAChB;;AAEA;IACI,kEAAkE;IAClE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;;IAEnB,mBAAmB;IACnB,yBAAyB;IACzB,uDAAuD;IACvD,mBAAmB;;IAEnB,WAAW;IACX,eAAe;IACf,aAAa;AACjB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,sBAAsB;IACtB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,0CAA0C;IAC1C,aAAa;IACb,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,eAAe;IACf,WAAW;AACf;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,WAAW;IACX,kBAAkB;IAClB,gCAAgC;AACpC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,OAAO;IACP,kBAAkB;AACtB","sourcesContent":[".MindmapDashboard{\n    padding: 16px 22px;\n    background: #f9f9f6;\n    height: 100%;\n}\n\n.MindmapDashboard_list{\n    display: flex;\n    flex-wrap: wrap;\n    --cols: 4;\n    --gap: 39px;\n    gap: var(--gap);\n}\n\n.MindmapDashboard_icon--add{\n    width: 36px;\n    height: 36px;\n    background-position: center;\n    background-repeat: no-repeat;\n    background-size: cover;\n    background-image: url(\"../../assets/notesEditor/add.svg\");\n    opacity: 0.4;\n}\n\n.MindmapDashboard_item{\n    width: calc((100% - var(--gap) * (var(--cols) - 1)) / var(--cols));\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 9px;\n}\n\n.MindmapDashboard_item_preview{\n    display: flex;\n    justify-content: center;\n    align-items: center;\n\n    background: #FFFFFF;\n    border: 1px solid #CAC4D0;\n    box-shadow: 0px 4px 31.4423px rgba(202, 196, 208, 0.56);\n    border-radius: 30px;\n\n    width: 100%;\n    aspect-ratio: 1;\n    padding: 11px;\n}\n\n.MindmapDashboard_item_preview:hover{\n    border: 1px solid #5f59fb;\n}\n\n.MindmapDashboard_item_content{\n    border-radius: 20px;\n    background-color: #ccc;\n    width: 100%;\n    height: 100%;\n    position: relative;\n    overflow: hidden;\n}\n\n.MindmapDashboard_item_name{\n    font-weight: 400;\n    font-size: 16px;\n    line-height: 15px;\n    text-align: center;\n    color: #000000;\n}\n\n.MindmapDashboard_contextMenu {\n    position: fixed;\n    background: white;\n    border: 1px solid #E2E9FC;\n    border-radius: 8px;\n    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.15);\n    z-index: 1000;\n    min-width: 140px;\n    padding: 4px 0;\n}\n\n.MindmapDashboard_contextMenu_item {\n    padding: 8px 16px;\n    cursor: pointer;\n    font-size: 14px;\n    color: #333;\n}\n\n.MindmapDashboard_contextMenu_item:hover {\n    background: #f5f5f5;\n}\n\n.MindmapDashboard_contextMenu_item--danger {\n    color: #ff4444;\n}\n\n.MindmapDashboard_contextMenu_item--danger:hover {\n    background: #fff0f0;\n}\n\n.MindmapDashboard_contextMenu_confirm {\n    padding: 8px 16px;\n    font-size: 14px;\n    color: #333;\n    text-align: center;\n    border-bottom: 1px solid #E2E9FC;\n}\n\n.MindmapDashboard_contextMenu_actions {\n    display: flex;\n}\n\n.MindmapDashboard_contextMenu_actions .MindmapDashboard_contextMenu_item {\n    flex: 1;\n    text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
